import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  styled
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  content: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ButtonStyled = styled(Button)({
    borderRadius: '24px',
    padding: '6px 50px',
  });

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = 'Confirm',
  content,
  onConfirm,
  onCancel,
}) => {
    useEffect(() => {
        // open and close
    },[open])
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <ButtonStyled
            variant="outlined"
            color="secondary"
            onClick={onCancel}
        >Cancel</ButtonStyled>

        <ButtonStyled
            data-testId="confirm-ok"
            variant="contained"
            color="primary"
            onClick={onConfirm}
        >OK</ButtonStyled>

      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;